import { HANDLED_RETURN_KEY } from '../common/constants/redirectReturn';

const RETURN_PARAM = 'payment_id';

export function hasRedirectReturn(search?: string): boolean {
  const query = search ?? (import.meta.client ? globalThis.location.search : '');
  const paymentId = new URLSearchParams(query).get(RETURN_PARAM);
  if (!paymentId) return false;

  try {
    return sessionStorage.getItem(HANDLED_RETURN_KEY) !== paymentId;
  } catch {
    return true;
  }
}
